// src/services/favoritesService.js
// Service pour gérer les favoris (appels API backend)

import api from './api';

const favoritesService = {
  /**
   * 🔹 Ajouter un salon aux favoris
   * @param {string} salonId - ID du salon
   * @returns {Promise} Réponse API
   */
  async addToFavorites(salonId) {
    try {
      const response = await api.post('/favorites', { salonId });
      return response.data;
    } catch (error) {
      console.error('❌ Erreur addToFavorites:', error);
      throw error;
    }
  },

  /**
   * 🔹 Retirer un salon des favoris
   * @param {string} salonId - ID du salon
   * @returns {Promise} Réponse API
   */
  async removeFromFavorites(salonId) {
    try {
      const response = await api.delete(`/favorites/${salonId}`);
      return response.data;
    } catch (error) {
      console.error('❌ Erreur removeFromFavorites:', error);
      throw error;
    }
  },

  /**
   * 🔹 Toggle favori (ajouter/retirer en 1 clic)
   * @param {string} salonId - ID du salon
   * @returns {Promise} { isFavorite: boolean, message: string }
   */
  async toggleFavorite(salonId) {
    try {
      const response = await api.post('/favorites/toggle', { salonId });
      return response.data;
    } catch (error) {
      console.error('❌ Erreur toggleFavorite:', error);
      throw error;
    }
  },

  /**
   * 🔹 Vérifier si un salon est en favori
   * @param {string} salonId - ID du salon
   * @returns {Promise} { isFavorite: boolean }
   */
  async checkFavorite(salonId) {
    try {
      const response = await api.get(`/favorites/check/${salonId}`);
      return response.data.data.isFavorite;
    } catch (error) {
      console.error('❌ Erreur checkFavorite:', error);
      throw error;
    }
  },

  /**
   * 🔹 Récupérer tous les salons favoris de l'utilisateur
   * @returns {Promise} Liste des salons favoris
   */
  async getUserFavorites() {
    try {
      const response = await api.get('/favorites');
      return response.data.data; // Array de salons
    } catch (error) {
      console.error('❌ Erreur getUserFavorites:', error);
      throw error;
    }
  },

  /**
   * 🔹 Récupérer le nombre de favoris
   * @returns {Promise} Nombre de favoris
   */
  async getFavoritesCount() {
    try {
      const response = await api.get('/favorites/count');
      return response.data.data.count;
    } catch (error) {
      console.error('❌ Erreur getFavoritesCount:', error);
      throw error;
    }
  },

  /**
   * 🔹 Récupérer le nombre de fois qu'un salon est favori (stats publiques)
   * @param {string} salonId - ID du salon
   * @returns {Promise} Nombre de favoris
   */
  async getSalonFavoritesCount(salonId) {
    try {
      const response = await api.get(`/favorites/salon/${salonId}/count`);
      return response.data.data.favoritesCount;
    } catch (error) {
      console.error('❌ Erreur getSalonFavoritesCount:', error);
      throw error;
    }
  }
};

export default favoritesService;